import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles((theme) => ({
    componentWrapper: {
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
    },
}), { name: 'not-working' });
